import { getHeaders } from '../../../api';

export const startSync = (idToken: string): Promise<Response> => {
    return fetch('/api/sync-facility', {
        headers: getHeaders(idToken),
    });
};
